export const SENTRY_CLIENT_DSN = process.env.REACT_APP_SENTRY_CLIENT_DSN;
export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '';
export const STRIPE_PAYMENT_INTENT_SECRET_URL = process.env.REACT_APP_STRIPE_PAYMENT_INTENT_SECRET_URL || '';
export const FIREBASE_WEB_API_KEY = process.env.REACT_APP_FIREBASE_WEB_API_KEY;
export const FIREBASE_DATABASE_URL = process.env.REACT_APP_FIREBASE_DATABASE_URL;
export const FIREBASE_PROJECT_ID = process.env.REACT_APP_FIREBASE_PROJECT_ID;
